(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/redux/actions.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/redux/actions.js');
"use strict";


const _svs$tickets_giftshop = svs.tickets_giftshop.constants.names,
  EMAIL = _svs$tickets_giftshop.EMAIL,
  GREETING = _svs$tickets_giftshop.GREETING,
  NAME = _svs$tickets_giftshop.NAME,
  PHONE = _svs$tickets_giftshop.PHONE,
  DATE = _svs$tickets_giftshop.DATE,
  TIME = _svs$tickets_giftshop.TIME,
  DATE_AND_TIME = _svs$tickets_giftshop.DATE_AND_TIME,
  DATE_TIME_AND_NAME = _svs$tickets_giftshop.DATE_TIME_AND_NAME,
  DATE_SELECTOR = _svs$tickets_giftshop.DATE_SELECTOR,
  PERSONAL_GREETING = _svs$tickets_giftshop.PERSONAL_GREETING;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.gift.giftform.actiontypes,
  INPUT_SET_PERSONAL_GREETING = _svs$tickets_giftshop2.INPUT_SET_PERSONAL_GREETING,
  INPUT_SET_GREETING = _svs$tickets_giftshop2.INPUT_SET_GREETING,
  INPUT_SET_NAME = _svs$tickets_giftshop2.INPUT_SET_NAME,
  INPUT_SET_EMAIL = _svs$tickets_giftshop2.INPUT_SET_EMAIL,
  INPUT_SET_PHONE = _svs$tickets_giftshop2.INPUT_SET_PHONE,
  INPUT_SET_RECEIVER_TYPE = _svs$tickets_giftshop2.INPUT_SET_RECEIVER_TYPE,
  INPUT_SET_DATE = _svs$tickets_giftshop2.INPUT_SET_DATE,
  INPUT_SET_TIME = _svs$tickets_giftshop2.INPUT_SET_TIME,
  INPUT_SET_DATE_AND_TIME = _svs$tickets_giftshop2.INPUT_SET_DATE_AND_TIME,
  INPUT_SET_DATE_TIME_AND_NAME = _svs$tickets_giftshop2.INPUT_SET_DATE_TIME_AND_NAME,
  SET_DATE_SELECTOR = _svs$tickets_giftshop2.SET_DATE_SELECTOR,
  FORM_CLEAR = _svs$tickets_giftshop2.FORM_CLEAR;
const setDateAction = date => ({
  type: INPUT_SET_DATE,
  payload: date
});
const setTimeAction = time => ({
  type: INPUT_SET_TIME,
  payload: time
});
const formClearAction = () => ({
  type: FORM_CLEAR
});
const inputChangeAction = _ref => {
  let field = _ref.field,
    value = _ref.value;
  const action = {
    payload: value
  };
  switch (field) {
    case EMAIL:
      action.type = INPUT_SET_EMAIL;
      break;
    case PERSONAL_GREETING:
      action.type = INPUT_SET_PERSONAL_GREETING;
      break;
    case GREETING:
      action.type = INPUT_SET_GREETING;
      break;
    case NAME:
      action.type = INPUT_SET_NAME;
      break;
    case PHONE:
      action.type = INPUT_SET_PHONE;
      break;
    case DATE:
      action.type = INPUT_SET_DATE;
      break;
    case TIME:
      action.type = INPUT_SET_TIME;
      break;
    case DATE_AND_TIME:
      action.type = INPUT_SET_DATE_AND_TIME;
      break;
    case DATE_TIME_AND_NAME:
      action.type = INPUT_SET_DATE_TIME_AND_NAME;
      break;
    case DATE_SELECTOR:
      action.type = SET_DATE_SELECTOR;
      break;
    default:
      break;
  }
  return action;
};
const receiverTypeChangeAction = _ref2 => {
  let value = _ref2.value;
  return {
    type: INPUT_SET_RECEIVER_TYPE,
    payload: value
  };
};
svs.tickets_giftshop.gift.giftform.actions = {
  inputChangeAction,
  receiverTypeChangeAction,
  formClearAction,
  setDateAction,
  setTimeAction
};

 })(window);